import './dashboard.css';
import { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux'
import { Link, Outlet, useNavigate } from 'react-router-dom';
import NavbarDashboard from '../NavbarDashboard';
import NavbarButtom from '../NavbarBottom';
// import Header from '../Header-item';
import 'react-toastify/dist/ReactToastify.min.css';
import { ToastContainer, toast } from 'react-toastify';

function Dashboard (props) {
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const {username,mobile,email,role} = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : []
  if(role != 1) {
    // localStorage.removeItem('token')
    // navigate('/', {replace: true})
  }

 
  useEffect(() => {
    console.log(token);
    if(!token){
        localStorage.removeItem('token')
      navigate('/', {replace: true})
    }


    if(token && role && role == 2){
        navigate('/agent')
    }else if(token && role && role == 3){
        navigate('/exhibition')
    }
    
},[])

 
  return (
    <main>
      <>
      {
        token ? (
          <NavbarDashboard logo={props.logo} mobile={mobile} />
        ): null
      }
     
      <div className="main-content"><Outlet context={[props.url]} /></div>
              
      <ToastContainer />
      {
        token ? (
          <NavbarButtom />
        ): null
      }
      </> 
      </main>
  )
}

export default Dashboard;